






































































































































import {
  computed,
  defineComponent,
  useRoute,
  useFetch,
} from '@nuxtjs/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
import orderGetters from '~/modules/checkout/getters/orderGetters';
import customerRequestQuotesGetters from '~/modules/request-quote/getters/customerRequestQuotesGetters';
import { useUiHelpers } from '~/composables';
import {
  SfTable, SfTableData, SfTableHeader, SfTableHeading, SfTableRow, SfSelect, SfSelectOption, SfButton, SfPagination, SfLoader,
} from '~/components/StorefrontUi';
import { useRequestQuote } from '~/modules/request-quote/composables/useRequestQuote';
import { RequestQuoteStatusMap } from '~/modules/request-quote/types';

export default defineComponent({
  name: 'NegotiatedOffers',
  components: {
    LazyHydrate,
    SfButton,
    SfPagination,
    SfSelect,
    SfSelectOption,
    SfTable,
    SfTableHeading,
    SfTableHeader,
    SfTableRow,
    SfTableData,
    SfLoader,
  },
  setup() {
    const { handleSearchCustomerRequestQuotes, customerRequestQuotes, handleMoveInCart } = useRequestQuote();
    const route = useRoute();
    const th = useUiHelpers();
    const {
      query: { page, itemsPerPage },
    } = route.value;

    const { fetch } = useFetch(async () => {
      await handleSearchCustomerRequestQuotes({
        currentPage: Number.parseInt(page as string, 10) || 1,
        pageSize: Number.parseInt(itemsPerPage as string, 10) || 10,
      });
    });
    fetch();

    const tableHeaders = ['offer no.', 'date of submission', 'suggested price', 'Status', 'Expiration date'];

    const pagination = computed(() => customerRequestQuotesGetters.getPagination(customerRequestQuotes.value));

    return {
      orderGetters,
      getDate: customerRequestQuotesGetters.getDate,
      getGrandTotal: customerRequestQuotesGetters.getGrandTotal,
      getOrderCurrency: customerRequestQuotesGetters.getCurrency,
      status: customerRequestQuotesGetters.getStatus,
      getExpirationDate: customerRequestQuotesGetters.getExpirationDate,
      orders: computed(() => customerRequestQuotes.value?.items ?? []),
      rawCustomerOrders: customerRequestQuotes,
      pagination,
      tableHeaders,
      th,
      handleMoveInCart,
      RequestQuoteStatusMap,
    };
  },
});
